import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectLanguage } from '../redux/features/languageTranslation/languageSlice'
import {
  guestToggleLanguage,
  loadTranslationsFile,
  toggleLanguage,
} from '../redux/features/languageTranslation/languageThunk'

let isJsonFileLoaded = false

const UseTranslation = () => {
  const translationState = useSelector(selectLanguage)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!isJsonFileLoaded) {
      dispatch(loadTranslationsFile())
      isJsonFileLoaded = true
    }
  }, [])

  const toggleAllLanguages = () => {
    dispatch(toggleLanguage())
  }
  const toggleGuestAllLanguages = () => {
    dispatch(guestToggleLanguage())
  }

  return { language: translationState.language,
    t: translationState.translations,
    toggleAllLanguages,
    toggleGuestAllLanguages }
}
export const translateMessage = (messageKey) => {
  const { t } = UseTranslation()
  return t[messageKey]
}

export default UseTranslation;
